export default "__VITE_ASSET__45854145__"